import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { InputProps } from "./interface";
import { Input as InputComponent, Container, SearchResultContainer, SearchResultItem } from "./styles";

const Input= ({
  isSearchField,
  setValue,
  searchResults,
  searchTrasitionTable,
  searchType,
  value,
  ...htmlAtt
}: InputProps) => {
  const maxWidth900 = 900;
  const [focus, setFocus] = useState(false);
  const [establishmentTooltip, setEstablishmentTooltip] = useState(false)

  const showResultContainer = () => {
    if(value !== "" && focus === true){
      return (
        <Container>
          <SearchResultContainer >
            {whatTypeSearch(`${searchType}`)}
          </SearchResultContainer>
        </Container>
      )
    } else {
      return null;
    }
  }

  const whatTypeSearch = (type: string) => {
    switch (type) {
      case "name":
        return searchResultItemGenerator()
      
      case "status": 
        return searchResultStatusItemGenerator()
      
      case "campanha": 
        return searchResultCampaingsItemGenerator()
      
      case "branch":
        return searchResultBranchsItemGenerator()

      case "category":
          return searchResultCategoriesItemGenerator()

      case "bank":
        return searchResultBankItemGenerator()

      default:
        searchResultItemGenerator()
    }
  }

  const status = [
    "Cancelada",
    "Aprovada",
    "Falhada",
  ]



  const searchResultStatusItemGenerator = () => {
    return status?.map((type, index) => {
      return <SearchResultItem key={index} onClick={() => {
        setValue !== undefined
        ? setValue(type)
        : null
        setFocus(false);
      }}>{type}</SearchResultItem>
    })
  }

  const searchResultBranchsItemGenerator = () => {
    return searchResults?.map((result) => {
      return <SearchResultItem key={result.id}
        onMouseEnter={() => {setEstablishmentTooltip(true)}}
        onMouseLeave={() => {setEstablishmentTooltip(false)}}
        onClick={() => {
            if(setValue !== undefined){
              setValue({
                businessName: result.businessName, 
                sellerOwnerPayId: result.sellerOwnerPayId,
                id: result.id
              })
        }
        setFocus(false);
      }}>
        <OverlayTrigger
          placement={innerWidth < maxWidth900 ? "bottom" : "left"}
          overlay={
            <Tooltip id="button-tooltip">
              {result.businessName}
            </Tooltip>
          }
        >
          <span>
            {result.businessName?.slice(0, 32) + "..."}
          </span>
        </OverlayTrigger>
      </SearchResultItem>
    })
  }

  const searchResultCategoriesItemGenerator = () => {
    return searchResults?.map((result, index) => {
      return <SearchResultItem key={index} onClick={() => {
            if(setValue !== undefined){
              setValue(result.description)
        }
        
        setFocus(false);
      }}>{result.description}</SearchResultItem>
    })
  }

  const searchResultBankItemGenerator = () => {
    return searchResults?.map((result, index) => {
      return <SearchResultItem key={index} onClick={() => {
            if(setValue !== undefined){
              setValue(result.label)
        }
        
        setFocus(false);
      }}>{result.label}</SearchResultItem>
    })
  }

  const searchResultCampaingsItemGenerator = () => {
    return searchResults?.map(result => {
      return <SearchResultItem key={result.tr_id} onClick={() => {
            if(setValue !== undefined){
              setValue(result.description)
        }
        
        setFocus(false);
      }}>{result.description}</SearchResultItem>
    })
  }

  const searchResultItemGenerator = () => {
    return searchResults?.map(result => {
      return <SearchResultItem key={result.id} onClick={() => {
        switch (searchTrasitionTable) {
          case true:
            if(setValue !== undefined){
              setValue(result.firstName)
            }

            break;
        
          default:
            if(setValue !== undefined){
              setValue(result)
            }
            
            break;
        }
        
        setFocus(false);
      }}>{result.name ? result.name : reduceClientNameLength(`${result.firstName} ${result.lastName}`)}</SearchResultItem>
    })
  }

  const reduceClientNameLength = (clientName: string) => {
    if(clientName.length >= 28){
      return `${clientName.slice(0, 27)}...`
    } else {
      return clientName;
    }
  }

  return (
    <>
      <InputComponent {...htmlAtt} value={value} 
        onFocus={() => setFocus(true)}
      />
      { isSearchField && value !== "" ? showResultContainer() : null }
    </>
  ); 
}

export default Input;